function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.80312 1.64768C8.06567 1.38513 8.06567 0.959457 7.80312 0.69691C7.54057 0.434363 7.1149 0.434364 6.85235 0.696911L3.99982 3.54944L1.14768 0.69729C0.885129 0.434743 0.459457 0.434743 0.19691 0.69729C-0.0656372 0.959837 -0.0656363 1.38551 0.196911 1.64806L3.04906 4.50021L0.19699 7.35227C-0.0655567 7.61482 -0.0655567 8.04049 0.19699 8.30304C0.459537 8.56559 0.88521 8.56558 1.14776 8.30304L3.99982 5.45097L6.85227 8.30342C7.11482 8.56597 7.54049 8.56597 7.80304 8.30342C8.06559 8.04087 8.06559 7.6152 7.80304 7.35265L4.95059 4.5002L7.80312 1.64768Z",
  fill: "#C1C1C1"
});

var SvgCloseIconGray = function SvgCloseIconGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIconGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon-gray.7c8bfc95.svg";
export { ForwardRef as ReactComponent };